var React = require('react');

function CloseModal (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M3.06043 5.06066C2.47465 4.47487 2.47465 3.52513 3.06043 2.93934C3.64622 2.35355 4.59597 2.35355 5.18175 2.93934L20.031 17.7886C20.6168 18.3744 20.6168 19.3241 20.031 19.9099C19.4452 20.4957 18.4955 20.4957 17.9097 19.9099L3.06043 5.06066Z","fill":"#181818","key":0}),React.createElement("path",{"d":"M17.9391 3.06066C18.5249 2.47487 19.4746 2.47487 20.0604 3.06066C20.6462 3.64645 20.6462 4.59619 20.0604 5.18198L5.21119 20.0312C4.62541 20.617 3.67566 20.617 3.08987 20.0312C2.50408 19.4454 2.50408 18.4957 3.08987 17.9099L17.9391 3.06066Z","fill":"#181818","key":1})]);
}

CloseModal.defaultProps = {"width":"23","height":"23","viewBox":"0 0 23 23","fill":"none"};

module.exports = CloseModal;

CloseModal.default = CloseModal;
